interface IAddScript {
  src: string;
  id: string;
  onLoad?: () => void;
}

export const addScript = ({ src, id, onLoad }: IAddScript) => {
  const existing = document.getElementById(id);
  if (!existing) {
    const script = document.createElement('script');
    script.src = src;
    script.id = id;
    script.async = true;
    script.onload = () => {
      if (onLoad) {
        onLoad();
      }
    };
    document.body.appendChild(script);
  }
};
